<template>
  <div>
    <a-row>
      <a-col :span="8">
        <a
          v-if="house !== undefined"
          target="_blank"
          :href="
            'https://console.leancloud.cn/apps/QoccwmtjlSyNmgzni7escoy9-gzGzoHsz/storage/data/House?query=%5B%5B%22objectId%22%2C%22equals%22%2C%22' +
            house.id +
            '%22%5D%5D'
          "
        >
          {{ house.id }}
        </a>
      </a-col>
    </a-row>
    <br />
    <a-row>
      <a-col :span="12">
        <div v-if="house.cleanHouseDate != undefined">
          清理房间数据日期：{{
            this.$moment(house.cleanHouseDate).format("YYYY-MM-DD")
          }}
        </div>
        <div v-else>未清理过数据</div>
      </a-col>
      <a-col :span="12">
        <a-button
          type="primary"
          @click="cleanUserHouseDataAction"
          :loading="loading"
        >
          清理房间数据
        </a-button>
      </a-col>
    </a-row>
    <br />
    <a-row>
      <a-col :span="12">
        <a-dropdown>
          <a v-if="house !== undefined" class="ant-dropdown-link">
            {{
              house.plan === undefined
                ? "无付费"
                : house.plan.name +
                  " - " +
                  (house.lastOrder.time === "month" ? "包月" : "包年")
            }}
            ->
            {{ changedHousePlanType }}
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="silver"> 白银会员 </a-menu-item>
            <a-menu-item key="gold"> 黄金会员 </a-menu-item>
            <a-menu-item key="platinum"> 白银会员 </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-col>
      <a-col :span="12">
        <a-date-picker
          v-if="house !== undefined"
          :default-value="house.planExpiredDate"
          :format="dateFormat"
          @change="planDateOnChange"
        />
      </a-col>
    </a-row>
    <br />
    <a-row>
      <a-col :span="12">
        <div>物品数量：{{ house.itemCount }} / {{ house.limit + (house.plan === undefined ? 0 : house.plan.itemCount) }}</div>
      </a-col>
      <a-col :span="12">
        <div>子物品数量：{{ house.subitemCount }}</div>
      </a-col>
    </a-row>
    <br />
    <a-row>
      <a-col :span="12">
        <div>回收站数量：{{ house.recycleItemCount }}</div>
      </a-col>
      <a-col :span="12">
        <div>
          文件空间：{{
            house.fileSize === undefined ? "0" : house.fileSize.toFixed(2)
          }}
          MB
        </div>
      </a-col>
    </a-row>
    <br />
    <a-row>
      <a-col :span="12">
        <div>
          分类空间：{{
            house.categoryCount === undefined ? "0" : house.categoryCount
          }}
        </div>
      </a-col>
      <a-col :span="12">
        <div>订单数量：{{ house.orderCount }}</div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
const AV = require("leancloud-storage");

export default {
  data() {
    return {
      loading: false,
      dateFormat: "YYYY/MM/DD",
      changedHousePlanType: "",
      changedHousePlanDate: "",
    };
  },
  props: ["house"],
  methods: {
    async cleanUserHouseDataAction() {
      this.loading = true;
      const result = await AV.Cloud.run("cleanUserHouseData", {
        houseId: this.house.id,
      });
      if (result) {
        // reload
        const result2 = await AV.Cloud.run("fetchAllHouse", {
          ownerId: this.house.owner.id,
        });
        this.house = result2[0];
      }
      this.loading = false;
    },
    planDateOnChange(date, dateString) {
      this.changedHousePlanDate = dateString;
      this.$emit(
        "changeHousePlan",
        this.house.id,
        this.changedHousePlanType,
        this.changedHousePlanDate
      );
    },
    handleMenuClick(e) {
      this.changedHousePlanType = e.key;
      this.$emit(
        "changeHousePlan",
        this.house.id,
        this.changedHousePlanType,
        this.changedHousePlanDate
      );
    },
  },
};
</script>

<style>
</style>